import RatingNote from './RatingNote';
export default RatingNote;
